import { type ReactNode } from 'react';
import { Modal } from '@/components/ui/modal';
import { Button } from '@/components/ui/button';
import type { Payment } from '../types';
import { formatUSD } from '../utils/payment-formatters';

type Props = {
  payment: Payment | null;
  onConfirm: () => void;
  onCancel: () => void;
  isPending: boolean;
};

function ConfirmActions(p: Omit<Props, 'payment'>): ReactNode {
  return (
    <div className="flex justify-end gap-sm">
      <Button
        variant="ghost"
        size="sm"
        onClick={p.onCancel}
        disabled={p.isPending}
      >
        Cancelar
      </Button>
      <Button
        variant="danger"
        size="sm"
        onClick={p.onConfirm}
        disabled={p.isPending}
      >
        {p.isPending ? 'Pagando…' : 'Pagar igualmente'}
      </Button>
    </div>
  );
}

function ConfirmBody(p: Props & { pay: Payment }): ReactNode {
  return (
    <div className="space-y-base">
      <p className="text-sm leading-relaxed text-text-secondary">
        <span className="font-medium text-text-primary">
          @{p.pay.collector_name}
        </span>{' '}
        tiene menos de $100 acumulados ({formatUSD(p.pay.total_earnings)}).
        ¿Seguro que quieres marcar este pago como realizado?
      </p>
      <ConfirmActions
        onConfirm={p.onConfirm}
        onCancel={p.onCancel}
        isPending={p.isPending}
      />
    </div>
  );
}

export function PaymentConfirmModal(p: Props): ReactNode {
  return (
    <Modal
      open={!!p.payment}
      onClose={p.onCancel}
      title="Pagar menos de $100"
      size="sm"
      dismissible={!p.isPending}
    >
      {p.payment && <ConfirmBody {...p} pay={p.payment} />}
    </Modal>
  );
}
